import { render, staticRenderFns } from "./OnlineService.vue?vue&type=template&id=225a943d&scoped=true&"
import script from "./OnlineService.vue?vue&type=script&lang=js&"
export * from "./OnlineService.vue?vue&type=script&lang=js&"
import style0 from "./OnlineService.vue?vue&type=style&index=0&id=225a943d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225a943d",
  null
  
)

export default component.exports